<template lang="pug">
.new-label
  shForm(title="Nueva Etiqueta")
</template>

<script>
import shForm from '@/components/pages/label/Form'

export default {
  name: 'NewLabel',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-label
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/label/New.vue